// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"yp-z","slideIn":"zp-z"};